module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../node_modules/happypack/loader.js?id=jsx!./RegisterView.js"));
	}, "RegisterView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=RegisterView!./src/pages/Register/RegisterView.js
// module id = 828
// module chunks = 431